import Vue from 'vue'
import Vuex from 'vuex'

import users from './modules/users'
import farms from './modules/farms'
import computers from './modules/computers'
import sensors_boxes from './modules/sensors_boxes'
import clients from './modules/clients'
import contracts from './modules/contracts'
import orders from './modules/orders'
import interventions from './modules/interventions'
import reports from './modules/reports'
import other_reports from './modules/other_reports'

Vue.use(Vuex)

export default new Vuex.Store({
	strict: false,
	modules: {
		users,
		farms,
		computers,
		sensors_boxes,
		clients,
		contracts,
		orders,
		interventions,
		reports,
		other_reports
	},
	state: {
		loading: false,
		uploading: null,
		roles: []
	},
	getters: {
		IS_CLIENT(state) {
			return state.roles.includes('Cliente')
		},
		IS_READONLY(state) {
			return state.roles.includes('Solo consulta')
		}
	},
	mutations: {
		loading(state, val) {
			state.loading = val
		},
		uploading(state, progress) {
			state.uploading = progress
		},
		loadRoles(state) {
			const storage = JSON.parse(localStorage.getItem('roles'))
			state.roles = storage || []
		}
	}
})
